<template>
  <div class="article-content">
    <template v-for="(element,i) in elements">
      <!--文本元素-->
      <template v-if="element.nodeName.toLowerCase()==='#text'">
        {{ element.data }}
      </template>
      <!--其他元素-->
      <template v-else>
        <content-element
          :key="i"
          :html="parseElementToHtml(element)"
          @click-image="handleImageClick"
          @load-image="handleImageLoad"
        />
      </template>
    </template>
  </div>
</template>

<script>
import ContentElement from './ContentElement'
import { parseHtmlToElements, parseElementsToHtml } from '@/utils'

export default {
  components: {
    ContentElement
  },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    elements() {
      return parseHtmlToElements(this.content)
    }
  },
  methods: {
    parseElementToHtml(element) {
      return parseElementsToHtml([element.cloneNode(true)])
    },
    handleImageClick(event) {
      this.$emit('click-image', event)
    },
    handleImageLoad(event) {
      this.$emit('load-image', event)
    }
  }
}
</script>

<style  lang="scss">
.article-content {
  p {
    margin: 0px;
    padding: 0px;
  }
  .van-image {
    display: block;
  }
}
</style>
<style scoped lang="scss">
  .article-content {
    padding: 0 10px;
    color: #444;
    font-size: 14px;
    line-height: 30px;
    text-indent: 2em;
  }
</style>
